import { CONTAINER_ARGS, Metadata, pick } from '../../../utils/spds/metadata';
import { TYPOGRAPHY_CAPTION_CLASS } from '../../../utils/spds/constants/typography';
import Super from './base.gjs';
import styles from './caption.module.scss';

const METADATA = Metadata.define({
  description: `
    SPDS Caption typography — the smallest running-text style, used for helper text, metadata,
    and small annotations (0.688rem / 11px).

    Extends \`Spds::Typography::Base\` with an inline \`span\` default that can be overridden via
    \`@tag\`. Pass \`@strong\` to render the semibold variant. Also serves as the base for the
    smaller \`Caption::Small\` size.
  `,
  extends: [
    pick(CONTAINER_ARGS, [
      { name: 'inline', default: true },
      { name: 'tag', default: 'span' },
    ]),
  ],
  name: 'Caption',
});

export default class SpdsTypographyCaption extends Super {
  static metadata = this.setMetadata(METADATA, import.meta.url);
  styles = styles;
  variantClass = TYPOGRAPHY_CAPTION_CLASS;
}

export const TYPOGRAPHY_CAPTION_METADATA = SpdsTypographyCaption.metadata;
